export const REACT_LOTTIE_PLAYER_VERSION = "3.6.0"; 
export const LOTTIE_WEB_VERSION = "^5.12.2";
